import { create } from 'zustand';

interface LoadingState {
  isLoadingIndicator: boolean;
  setLoading: (loading: boolean) => void;
  isPolling: boolean;
  setPolling: (polling: boolean) => void;
}

export const useLoadingStore = create<LoadingState>((set) => ({
  isLoadingIndicator: false,
  setLoading: (loading) => set({ isLoadingIndicator: loading }),
  isPolling: false,
  setPolling: (polling) => set({ isPolling: polling })
})); 